import React from 'react';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';

export interface ResourceLinkProps {
  href: string;
  icon: React.ReactNode;
  title: string;
  wrapTitleInSpan?: boolean;
}

export type ResourceLinkComponent = React.FC<ResourceLinkProps>;

const ResourceLink: ResourceLinkComponent = ({
  href,
  icon,
  title,
  wrapTitleInSpan = true,
}) => {
  return (
    <a
      href={href}
      className={classes['resource-item']}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={classes['resource-info']}>
        <div className={classes['resource-title']}>
          {icon}{' '}
          {wrapTitleInSpan ? (
            <span className={classes['resource-title-text']}>{title}</span>
          ) : (
            title
          )}
        </div>
      </div>

      <div className={classes['resource-icon']}>
        <Icon name="launch" size={16} aria-hidden="true" />
      </div>
    </a>
  );
};

export default ResourceLink;
